import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import ChangePassword from '../components/Settings/ChangePassword'
const { TabPane } = Tabs;

const Setting = () => {
  const [tabPosition, setTabPosition] = useState('left');

  useEffect(() => {
    const handleResize = () => {
      setTabPosition(window.innerWidth < 768 ? 'top' : 'left');
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial tab position
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Tabs tabPosition={tabPosition} defaultActiveKey="1">
      <TabPane tab="CHANGE PASSWORD" key="1">
        <ChangePassword/>
      </TabPane>
      {/* <TabPane tab="PAUSE " key="2">
        More setting
      </TabPane>
      <TabPane tab="SUBSCRIPTION SETTINGS" key="3">
        More settings
      </TabPane>
      <TabPane tab="MORE SETTINGS" key="4">
        More settings
      </TabPane> */}
    </Tabs>
  );
};

export default Setting;